export const HIGHLIGHTS_DISPLAY_LINE_THRESHOLD = 3;

export const TRAINING_DISPLAY_LINE_THRESHOLD = 10;

export const APPROX_CHARS_PER_LINE_DESKTOP = 135;

export const APPROX_CHARS_PER_LINE_TABLET = 110;

export const APPROX_CHARS_PER_LINE_MOBILE = 45;

/** ~linesNumber is lines of text per breakpoint (sm / md / lg) for consistent fold */
export const HIGHLIGHTS_SHOW_MORE_CHAR_THRESHOLD_BY_BREAKPOINT = {
  sm: HIGHLIGHTS_DISPLAY_LINE_THRESHOLD * APPROX_CHARS_PER_LINE_MOBILE,
  md: HIGHLIGHTS_DISPLAY_LINE_THRESHOLD * APPROX_CHARS_PER_LINE_TABLET,
  lg: HIGHLIGHTS_DISPLAY_LINE_THRESHOLD * APPROX_CHARS_PER_LINE_DESKTOP,
} as const;

export const MAX_HIGHLIGHTS_CHAR_LENGTH = 2000;

export const MAX_HIGHLIGHTS_WARNING_CHAR_LENGTH = 1900;

export const MAX_PRONOUNS_PRONUNCIATION_CHAR_LENGTH = 50;
